import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setActiveItem } from "../store/uiSlice";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../Styles/SideNavBar.css";
const user = JSON.parse(localStorage.getItem("user"));
const userRole = user?.role || null;

const SideNavBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

const baseMenuItems = [
  { name: "Home", route: "/", icon: "fa fa-home", allowedRoles: ['masterAdmin','admin','sales'] },
  { name: "Accommodations", route: "/Accommodations", icon: "fa fa-bed", allowedRoles: ['masterAdmin','admin'] },
  { name: "Bundles", route: "/ictLearningBundle", icon: "fa fa-gift", allowedRoles: ['masterAdmin','admin','sales'] },
  { name: "Domains", route: "/ictDomainManager", icon: "fa fa-laptop", allowedRoles: ['masterAdmin','admin','sales'] },
  { name: "Vendors", route: "/vendorsManager", icon: "fas fa-certificate", allowedRoles: ['masterAdmin','admin','sales'] },
  { name: "DC Lab Panel", route: "/DCData", icon: "fa fa-cloud", allowedRoles: ['masterAdmin','admin'] },
  { name: "Enquiries", route: "/IctEnquiry", icon: "fa fa-envelope", allowedRoles: ['masterAdmin','admin','sales'] },
  { name: "Events", route: "/events", icon: "fas fa-bullhorn", allowedRoles: ['masterAdmin','admin','sales'] },
  { name: "Employee Panel", route: "/ictEmpDataManager", icon: "fas fa-id-card-alt", allowedRoles: ['masterAdmin','admin'] },
  { name: "FAQ Panel", route: "/ictFAQManager", icon: "fa fa-question", allowedRoles: ["masterAdmin", "admin"] },
  { name: "Feedbacks Panel", route: "/ictFeedbacks", icon: "fa fa-comments", allowedRoles: ['masterAdmin','admin'] },
  { name: "ICT Data", route: "/ict-data", icon: "fa fa-database", allowedRoles: ['masterAdmin','admin','sales'] },
  { name: "ICT Details", route: "/ictdetails", icon: "fa fa-share-alt", allowedRoles: ['masterAdmin','admin'] },
  { name: "ICT Catalog", route: "/ict-Catalog", icon: "far fa-clone", allowedRoles: ['masterAdmin','admin','sales'] },
  { name: "ICT Modules", route: "/ictLearningModule", icon: "fa fa-clipboard", allowedRoles: ['masterAdmin','admin','sales'] },
  { name: "ICT Invoice", route: "/billInvoice", icon: "fa fa-file-text", allowedRoles: ['masterAdmin','admin'] },
  { name: "Leads Panel", route: "/ictLeads", icon: "fa fa-bell", allowedRoles: ['masterAdmin','admin','sales'] },
  { name: "Learners Panel", route: "/ictLearners", icon: "fa fa-users", allowedRoles: ['masterAdmin','admin','sales'] },
  { name: "Misc Expense", route: "/MiscExpenseManager", icon: "fa fa-unlink", allowedRoles: ['masterAdmin','admin'] },
  { name: "Study Material", route: "/study-materials", icon: "fa fa-book", allowedRoles: ['masterAdmin','admin'] },
  { name: "Recordings", route: "/ictRecording", icon: "fa fa-video", allowedRoles: ['masterAdmin','admin'] },
  { name: "Sales Card Panel", route: "/ICTSalesCard", icon: "fa fa-inr", allowedRoles: ['masterAdmin','admin'] },
  { name: "Training Panel", route: "/ictTrainingCard", icon: "fa fa-suitcase", allowedRoles: ['masterAdmin','admin'] },
  { name: "Trainers Panel", route: "/ictTrainersManager", icon: "fas fa-chalkboard-teacher", allowedRoles: ['masterAdmin','admin'] },
  { name: "Travel Manager", route: "/TraveManager", icon: "fa fa-plane", allowedRoles: ['masterAdmin','admin'] },
  { name: "Tour Manager", route: "/TourData", icon: "fa fa-cab", allowedRoles: ['masterAdmin','admin'] },
  { name: "Testimonials", route: "/testimonials", icon: "fas fa-rss-square", allowedRoles: ['masterAdmin','admin'] },
  { name: "Trainers By ICT", route: "/ictTrainersList", icon: "fas fa-list", allowedRoles: ['masterAdmin','admin'] },
];

const menuItems = baseMenuItems.filter((item) => {
  if (!item.allowedRoles) return true; // visible to all
  return item.allowedRoles.includes(userRole);
});
  
  const [isIconLayerVisible, setIsIconLayerVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleNavigation = (item) => {
    dispatch(setActiveItem(item.name));
    navigate(item.route);
  };

  const filteredItems = menuItems.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="sidebar-container">
      {!isIconLayerVisible ? (
        <div className="full-sidebar">
          <div className="sidebar-search">
            <input
              type="text"
              placeholder="Search menu..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="sidebar-search-input"
            />
          </div>
          <br/>
          <ul className="sidebar-menu">
            {filteredItems.map((item) => (
              <li
                key={item.name}
                className={
                  location.pathname === item.route
                    ? "sidebar-item active"
                    : "sidebar-item"
                }
                onClick={() => handleNavigation(item)}
              >
                <i className={`${item.icon} menu-icon`}></i>
                <span className="menu-text">{item.name}</span>
              </li>
            ))}
          </ul>
          <button className="toggle-btn" onClick={() => setIsIconLayerVisible(true)}>
            <i className="fa fa-arrow-left"></i> Collapse
          </button>
        </div>
      ) : (
        <div className="icon-only-sidebar">
          <ul className="sidebar-icon-menu">
            {filteredItems.map((item) => (
              <li
                key={item.name}
                className={
                  location.pathname === item.route
                    ? "icon-item active"
                    : "icon-item"
                }
                onClick={() => handleNavigation(item)}
              >
                <i className={`${item.icon} menu-icon`}></i>
              </li>
            ))}
          </ul>
          <button className="toggle-btn" onClick={() => setIsIconLayerVisible(false)}>
            <i className="fa fa-arrow-right"></i> Expand
          </button>
        </div>
      )}
    </div>
  );
};

export default SideNavBar;
